<template>
  <v-container>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex xs12 class="text-xs-center" mt-5>
          <h1>Sign in</h1>
        </v-flex>
        <v-flex xs12 sm6 offset-sm3 mt-3>
          <v-flex>
            <v-alert type="error" dismissible v-model="error">{{ errorMessage }}</v-alert>
          </v-flex>
          <form v-on:keyup.13="signIn">
            <v-layout column>
              <v-flex>
                <v-text-field v-model="email" label="Email" id="email" type="email" autofocus required></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="passWord" label="Password" id="passWord" type="password" required></v-text-field>
              </v-flex>
              <v-flex>
                <v-btn id="btn-signin" color="primary" v-on:click="signIn">Sign In</v-btn>
              </v-flex>
            </v-layout>
          </form>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
  import * as firebase from "firebase/app";

  export default {
    data() {
      return {
        email: "",
        passWord: "",
        errorMessage: "",
        error: false
      };
    },
    methods: {
      signIn: function () {
        const email = this.email;
        const password = this.passWord;

        this.$store
          .dispatch("login", {
            email,
            password
          })
          .then(user => {
            this.error = false;
            this.$router.replace("AppContent");
          })
          .catch(err => {
            this.error = true;
            this.errorMessage = err.message;
          });
      }
    }
  };
</script>